import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

import Landing from "@/pages/Landing";
import SubmitJob from "@/pages/SubmitJob";
import CustomerLogin from "@/pages/CustomerLogin";
import Verify from "@/pages/Verify";
import CustomerDashboard from "@/pages/CustomerDashboard";
import AnswerQuestions from "@/pages/AnswerQuestions";
import AdminLogin from "@/pages/AdminLogin";
import AdminConsole from "@/pages/AdminConsole";
import AdminSettings from "@/pages/AdminSettings";

function Guard({ children, roles, redirect }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return <div className="min-h-screen grid place-items-center"><Loader2 className="animate-spin text-brand" size={30} /></div>;
  if (!user) return <Navigate to={redirect} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={redirect} replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/submit" element={<SubmitJob />} />
            <Route path="/login" element={<CustomerLogin />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/answer" element={<AnswerQuestions />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/dashboard" element={<Guard redirect="/login"><CustomerDashboard /></Guard>} />
            <Route path="/admin" element={<Guard roles={["admin", "staff"]} redirect="/admin/login"><AdminConsole /></Guard>} />
            <Route path="/admin/settings" element={<Guard roles={["admin"]} redirect="/admin/login"><AdminSettings /></Guard>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
